// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"a49440b2","123":"83749cb7","154":"c4f48e5f","239":"3356cce0","570":"3ab9ba2f","607":"38d9e6a5","608":"693afa1b","679":"bf602ed5","732":"bfe83eca","781":"2c0c5448","920":"f6dcc89d","948":"17731092","977":"0e05d741"}[chunkId] + ".chunk.js";
};